import { useNavigate } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmptyStateLayout } from 'modules/trainings/components/EmptyStateLayout'

import image from './images/myRequestsBlankSlate.png'

interface Props {
  emptyCatalog: boolean
  canCreate: boolean
}
export const EmptyState = ({ emptyCatalog, canCreate }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const navigateToCatalog = () => {
    navigate(navigation.trainings.catalog.list.fullPath())
    track(trackingEvents.training.trainingRequest.gotToTrainingCatalog, {
      from: 'employee_training_catalog_empty_space',
    })
  }

  const navigateToNewRequest = () => {
    navigate(navigation.myTrainings.requests.list.new.fullPath())
    track(trackingEvents.training.trainingRequest.addTrainingRequest.newProposal.start, {
      from: 'employee_training_catalog_empty_space',
    })
  }

  useEffect(() => {
    track(trackingEvents.training.trainingRequest.goToMyTrainingRequestsEmptyState)
  }, [])

  return (
    <EmptyStateLayout>
      <Box maxWidth="s600" minWidth="s600" maxHeight="s360" minHeight="s360">
        <img src={image}></img>
      </Box>
      <Box gap="s24" maxWidth="s400" textAlign="center" alignItems="center">
        {canCreate && (
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('trainings.training_requests.my_requests.empty_state.title')}
          </Text>
        )}
        {!canCreate && (
          <>
            <Text size="400" color="grey1000" weight="semibold">
              {i18n.t('trainings.training_requests.my_requests.empty_state.title_no_permissions')}
            </Text>
            <Text size="300" color="grey800" weight="normal">
              {i18n.t(
                'trainings.training_requests.my_requests.empty_state.description_no_permissions'
              )}
            </Text>
          </>
        )}
        {canCreate && (
          <Button iconName="add" onClick={navigateToNewRequest}>
            {i18n.t('trainings.training_requests.my_requests.empty_state.cta')}
          </Button>
        )}
        {!emptyCatalog && canCreate && (
          <Box
            cursor="pointer"
            onClick={navigateToCatalog}
            flexDirection="row"
            alignItems="center"
            gap="s4"
          >
            <Text size="300" color="grey1000" weight="medium">
              {i18n.t('trainings.training_requests.my_requests.check_catalog')}
            </Text>
            <Icon.Medium icon="arrow-right" color="grey1000" />
          </Box>
        )}
      </Box>
    </EmptyStateLayout>
  )
}
